<template>
  <div class="data-park-basic">
    <breadcrumb :breadcrumb="breadcrumb" />

    <div style="display: flex;justify-content: space-between">
      <text-title mainTitle="园区基础信息" />
      <div class="operationBox" v-if="permissionCodes.indexOf('029001001') !== -1">
        <a @click="modifyState = false" v-if="modifyState">修改</a><a @click="cancelChangeDataParkBasicInfo" v-if="!modifyState">取消</a><a @click="confirmChangeDataParkBasicInfo" v-if="!modifyState">确定</a>
      </div>
    </div>

    <form>
      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">用地面积：</span>
        </div>
        <el-input type="text" v-model="dataParkBasic.ydmj" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">亩</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">楼栋数量：</span>
        </div>
        <el-input type="text" v-model="dataParkBasic.ldsl" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">栋</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">建筑面积：</span>
        </div>
        <el-input type="text" v-model="dataParkBasic.jzmj" size="small" style="width: 280px" :disabled="modifyState">
          <template slot="append">万平米</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">园区类型：</span>
        </div>
        <div>
          <el-select v-model="dataParkBasic.yqlx" placeholder="请选择" size="mini" style="width: 280px" :disabled="modifyState">
            <el-option
              v-for="item in yqlxList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">数字化园区建设等级：</span>
        </div>
        <div>
          <el-select v-model="dataParkBasic.jsdj" placeholder="请选择" size="mini" style="width: 280px" :disabled="modifyState">
            <el-option
              v-for="item in jsdjList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </div>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">主导产业：</span>
        </div>
        <el-input type="text" v-model="dataParkBasic.zdcy" size="small" style="width: 280px" :disabled="modifyState" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">园区投运时间：</span>
        </div>
        <el-input type="text" v-model="dataParkBasic.yqty" size="small" style="width: 280px" :disabled="modifyState" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">已建公共配套设施面积：</span>
        </div>
        <el-input type="text" v-model="dataParkBasic.ptss" size="small" style="width: 280px" :disabled="modifyState" />
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">自持面积：</span>
        </div>
        <el-input type="text" v-model="dataParkBasic.zcmj" size="small" style="width: 280px" :disabled="modifyState" >
          <template slot="append">万平米</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">已出售面积：</span>
        </div>
        <el-input type="text" v-model="dataParkBasic.csmj" size="small" style="width: 280px" :disabled="modifyState" >
          <template slot="append">万平米</template>
        </el-input>
      </div>

      <div class="form-line">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">已出租面积：</span>
        </div>
        <el-input type="text" v-model="dataParkBasic.czmj" size="small" style="width: 280px" :disabled="modifyState" >
          <template slot="append">万平米</template>
        </el-input>
      </div>

      <div class="form-line" v-if="modifyState">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">园区展示：</span>
        </div>
        <div style="width: 240px;height: 135px;margin-top: 20px;" v-if="dataParkBasic.ptssurlList">
          <el-carousel height="180px">
            <el-carousel-item v-for="item in dataParkBasic.ptssurlList" :key="item">
              <img :src="item" alt="" style="width: 240px;height: 135px;">
            </el-carousel-item>
          </el-carousel>
        </div>
        <div v-else>暂无</div>
      </div>

      <div class="form-line" v-if="!modifyState">
        <div class="textBox">
          <!--<b class="red">*</b>-->
          <span class="line-text">园区展示：</span>
        </div>
        <upload-img-list @getImgList="getImgList" :defaultImg="defaultImg" style="flex-wrap: wrap" />
      </div>
    </form>
  </div>
</template>

<script>
  import Breadcrumb from '../../../components/Breadcrumb/Breadcrumb'
  import {nError, nSuccess} from '../../../utils/notice'
  import TextTitle from '../../../components/Text/TextTitle'
  import {errorHandler} from '../../../utils/errorHandler'
  import {api} from '../../api/DataServicePark'
  import {bus} from '../../../utils/bus'
  import UploadImgList from "../../../components/Input/UploadImgList";

  export default {
    components: {
      UploadImgList,
      TextTitle,
      Breadcrumb
    },
    name: 'data-park-basic',
    data () {
      return {
        permissionCodes: '',
        breadcrumb: [{
          value: '园区数据',
          name: 'data-park-basic'
        }, {
          value: '园区基础信息'
        }],

        modifyState: true,
        yqlxList: [
          {
            value: '生产制造',
            label: '生产制造'
          },
          {
            value: '生产服务',
            label: '生产服务'
          },
        ],
        jsdjList: [
          {
            value: '1',
            label: '1'
          },
          {
            value: '2',
            label: '2'
          },
          {
            value: '3',
            label: '3'
          },
          {
            value: '4',
            label: '4'
          },
          {
            value: '5',
            label: '5'
          },
        ],
        dataParkBasic: {
          ydmj: '',
          ldsl: '',
          jzmj: '',
          yqlx: '',
          jsdj: '',
          zdcy: '',
          yqty: '',
          ptss: '',
          zcmj: '',
          csmj: '',
          czmj: '',
          ptssurlList: []
        },

        defaultImg: [],
        imageList: [],
        base64List: []
      }
    },
    created () {
      this.permissionCodes = bus.global.permissionCodes
      this.getParkBaseInfo()
    },
    methods: {
      getImgList (imageList, base64List) {
        this.imageList = imageList
        this.base64List = base64List
      },
      // 查询园区基本数据
      getParkBaseInfo () {
        this.$axios.get(`${api.getParkBaseInfo}`, {})
          .then(res => {
            let data = res.data.data
            this.dataParkBasic = data
          })
          .catch(errorHandler('查询园区基本数据失败'))
      },

      // 取消修改
      cancelChangeDataParkBasicInfo () {
        this.modifyState = true
        this.getParkBaseInfo()
      },

      // 确认修改园区基本数据
      async confirmChangeDataParkBasicInfo () {
        await this.upApartmentLayoutImageList()
        this.$axios.post(`${api.updateParkBaseInfo}`, this.dataParkBasic)
          .then(res => {
            this.modifyState = true
            this.getParkBaseInfo()
            nSuccess('修改成功')
          })
          .catch(errorHandler('修改失败'))
      },

      async upApartmentLayoutImageList () {
        let yqApartmentLayoutDiagramListArr = []
        for (let k = 0; k < this.imageList.length; k++) {
          if (!this.imageList[k].name) {
            yqApartmentLayoutDiagramListArr.push(this.imageList[k].src)
          }
          for (let j = 0; j < this.base64List.length; j++) {
            if (this.imageList[k].name && this.imageList[k].name.split('.')[0] === this.base64List[j].code) {
              let imgUrl = ''
              await this.uploadPictureToGetUrl(this.base64List[j].personImageStr)
                .then(res => {
                  imgUrl = res.data.data
                })
                .catch(errorHandler('图片上传失败'))
              yqApartmentLayoutDiagramListArr.push(imgUrl)
            }
          }
        }
        this.dataParkBasic.ptssurlList = yqApartmentLayoutDiagramListArr
      },

      // 上传图片
      uploadPictureToGetUrl (base64) {
        return this.$axios.post(api.uploadImg, {
          picData: base64
        })
      },
    }
  }
</script>

<style scoped>
  .operationBox {
    margin: 20px 0 10px 0;
  }
  .operationBox a {
    font-size: 14px;
    float: right;
    margin-right: 30px;
    color: #00A0E6;
  }
  form {
    width: 90%;
    margin: 0 auto;
    text-align: left;
  }
  .red {
    color: #FF0000;
    vertical-align: sub;
  }
  .form-line {
    margin: 20px 0;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }
  .form-line>div {
    margin-right: 20px;
  }
  .line-text{
    color: #48576a;
    font-size: 14px;
    margin-right: 10px;
  }
  .textBox {
    display: inline-block;
    width: 190px;
    line-height: 32px;
    text-align: right;
  }
  .form-btn-box {
    width: 530px;
    padding: 0 110px 0 140px;
    margin: 40px 0 0 0;
    display: flex;
    justify-content: space-between;
  }
  .newly2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    border: 1px dashed #D7D7D7;
    margin-right: 20px;
    position: relative;
  }
  .newly2 span {
    display: block;
    width: 100%;
    color: #999999;
    margin: 0;
    padding: 0;
    text-align: center;
  }
  .newly2 span:first-child {
    font-size: 36px;
    line-height: 120px;
    position: absolute;
    top: 15px;
  }
  .newly2 span:last-child {
    font-size: 14px;
    line-height: 50px;
    position: absolute;
    bottom: 0;
  }
  .upload2 {
    display: inline-block;
    width: 250px;
    height: 173px;
    vertical-align: text-top;
    background-size: 100% 100%;
    position: relative;
  }

  .upload2 img {
    width: 100%;
    height: 100%;
    border-radius: 5px;
  }
  .upload2 b {
    display: inline-block;
    width: 100%;
    line-height: 21px;
    color: white;
    background-color: #989796;
    text-align: center;
    position: absolute;
    bottom: 0;
    opacity: .7;
  }
</style>



// WEBPACK FOOTER //
// src/view/DataServicePark/DataParkBasic/DataParkBasic.vue